import { IComponentOptions } from 'angular';
import { ClassOfDropdownTransferCtrl } from './class-of-dropdown-transfer.controller';

export const ClassOfDropdownTransferComponent: IComponentOptions = {
  controller: ClassOfDropdownTransferCtrl,
  template: require('./class-of-dropdown-transfer.html'),
};
